import { useState } from 'react'
import { Link } from 'react-router-dom'
import { api, qs } from '../../lib/api.js'
import { Badge, Card, Empty, ErrorBox, Page, Spinner, useAsync } from '../../components/Ui.jsx'
import { lakh } from '../../lib/format.js'

export default function Hatcheries () {
  const [q, setQ] = useState('')
  const [search, setSearch] = useState('')
  const { data, error, loading, reload } = useAsync(() => api.get(`/admin/hatcheries${qs({ q: search })}`), [search], { live: ['hatcheries', 'batches'] })

  const rows = data?.hatcheries || []

  return (
    <Page
      title="Hatcheries"
      subtitle="Every hatchery on the platform. Open one to see its production batches, seed quality history, bookings and login."
      actions={<Link className="btn primary" to="/admin/hatcheries/new">Onboard hatchery</Link>}
    >
      <Card padded={false}>
        <div className="filterbar">
          <form onSubmit={e => { e.preventDefault(); setSearch(q) }} style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
            <label className="f">
              <span>Search</span>
              <input value={q} onChange={e => setQ(e.target.value)} placeholder="Name, code, village, owner" />
            </label>
            <button className="btn">Search</button>
            {search && <button type="button" className="btn ghost" onClick={() => { setQ(''); setSearch('') }}>Clear</button>}
          </form>
          <div className="spacer" style={{ flex: 1 }} />
          <div className="muted small">{rows.length} hatcher{rows.length === 1 ? 'y' : 'ies'}</div>
        </div>

        {loading
          ? <Spinner />
          : error
            ? <div className="body"><ErrorBox error={error} onRetry={reload} /></div>
            : (
              <div className="scroll-x">
                <table>
                  <thead>
                    <tr>
                      <th>Hatchery</th>
                      <th>Location</th>
                      <th className="num">From Kakinada</th>
                      <th className="num">Live batches</th>
                      <th className="num">Seed available</th>
                      <th className="num">Bookings</th>
                      <th>Login</th>
                      <th>Status</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map(h => (
                      <tr key={h._id}>
                        <td>
                          <Link className="rowlink" to={`/admin/hatcheries/${h._id}`}>{h.name}</Link>
                          <span className="t-sub mono">{h.code}</span>
                          {h.flagged > 0 && <><br /><Badge tone="bad">{h.flagged} flagged batch{h.flagged > 1 ? 'es' : ''}</Badge></>}
                        </td>
                        <td>
                          {h.place}
                          {h.ownerName && <span className="t-sub">{h.ownerName}{h.phone ? ` · ${h.phone}` : ''}</span>}
                        </td>
                        <td className="num">{h.distanceFromKakinadaKm} km</td>
                        <td className="num">{h.liveBatches}<span className="t-sub">of {h.batchCount}</span></td>
                        <td className="num">{lakh(h.availableLakh)}</td>
                        <td className="num">{h.ordersCount}</td>
                        <td>
                          {h.login
                            ? <span className="mono small">{h.login.username}{!h.login.active && ' (disabled)'}</span>
                            : <Badge tone="warn">No login</Badge>}
                        </td>
                        <td><Badge tone={h.status === 'active' ? 'good' : 'muted'}>{h.status}</Badge></td>
                        <td className="right"><Link className="btn sm" to={`/admin/hatcheries/${h._id}`}>Open</Link></td>
                      </tr>
                    ))}
                    {!rows.length && <tr><td colSpan={9}><Empty>No hatcheries match that search.</Empty></td></tr>}
                  </tbody>
                </table>
              </div>
              )}
      </Card>
    </Page>
  )
}
